// Write your code here
import './index.css'

const DenominationItem = props => {
  const {amount, cutAmount} = props

  const onClickBtn = () => {
    cutAmount(amount)
  }

  return (
    <li>
      <button type="button" onClick={onClickBtn}>
        {amount}
      </button>
    </li>
  )
}

export default DenominationItem
